export class GetIngestionPipelineSchemaResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableExists",
            "baseName": "tableExists",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<IcebergTableColumn>",
            "format": ""
        },
        {
            "name": "currentSnapshotId",
            "baseName": "currentSnapshotId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetIngestionPipelineSchemaResponse.attributeTypeMap;
    }
    constructor() {
    }
}
